import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = ({ isPlaying = true }) => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden -z-10 opacity-100">
      {/* Soft Floating Orbs */}
      <motion.div
        className="absolute w-48 h-48 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full blur-3xl"
        animate={{
          x: [0, 50, 0],
          y: [0, -30, 0],
          scale: isPlaying ? [1, 1.2, 1] : 1,
          opacity: isPlaying ? [0.5, 0.7, 0.5] : 0.3,
        }}
        transition={{ duration: isPlaying ? 20 : 0, repeat: Infinity, ease: 'easeInOut' }}
        style={{ top: '10%', left: '5%' }}
      />

      <motion.div
        className="absolute w-64 h-64 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full blur-3xl"
        animate={{
          x: [0, -60, 0],
          y: [0, 40, 0],
          scale: isPlaying ? [0.9, 1.1, 0.9] : 1,
          opacity: isPlaying ? [0.4, 0.6, 0.4] : 0.2,
        }}
        transition={{ duration: isPlaying ? 25 : 0, repeat: Infinity, ease: 'easeInOut', delay: 1 }}
        style={{ bottom: '10%', right: '5%' }}
      />

      <motion.div
        className="absolute w-56 h-56 bg-gradient-to-r from-lime-500 to-green-500 rounded-full blur-3xl"
        animate={{
          x: [0, 40, 0],
          y: [0, -50, 0],
          scale: isPlaying ? [1, 1.15, 1] : 1,
          opacity: isPlaying ? [0.45, 0.65, 0.45] : 0.25,
        }}
        transition={{ duration: isPlaying ? 30 : 0, repeat: Infinity, ease: 'easeInOut', delay: 2 }}
        style={{ top: '50%', right: '10%' }}
      />

      <motion.div
        className="absolute w-40 h-40 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full blur-3xl"
        animate={{
          x: [0, -50, 0],
          y: [0, 60, 0],
          scale: isPlaying ? [1, 1.1, 1] : 1,
          opacity: isPlaying ? [0.5, 0.7, 0.5] : 0.3,
        }}
        transition={{ duration: isPlaying ? 28 : 0, repeat: Infinity, ease: 'easeInOut', delay: 3 }}
        style={{ bottom: '20%', left: '10%' }}
      />

      {/* Subtle Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-950/5 to-transparent" />
    </div>
  );
};

export default AnimatedBackground;
